import { useEffect, useState } from "react";
import { getCustomisationValue } from "../../EditablePreview";

const ImageOverlayScaledImage = (props) => {
    console.log("ImageOverlayScaledImage props:", props);
    const customisationVars = props.node.customisationVars;

    const imageDataLink = 'customImageOverlay.imageFiles.customImageFile.filename';
    const imageIndex = props.activeNode?.parent === props.node ? props.activeNode?.dataIndex ?? 0 : 0;
    const imageData = getCustomisationValue(customisationVars, imageDataLink, imageIndex, props.visualisationComponentKey ?? null, props.selectedFeatureNode);

    const [imgSrc, setImgSrc] = useState(null);
    const [imgWidth, setImgWidth] = useState('100%');
    const [naturalWidth, setNaturalWidth] = useState(null);
    const [imgVisible, setImgVisible] = useState(false);
    useEffect(() => {
        setImgWidth('100%');
        setImgSrc(null);
        setNaturalWidth(null);
        setImgVisible(false);
        setTimeout(() => {
            const imageDataLink = 'customImageOverlay.imageFiles.customImageFile.filename';
            const imageData = getCustomisationValue(customisationVars, imageDataLink, imageIndex, props.visualisationComponentKey ?? null, props.selectedFeatureNode);
            if (imageData && typeof imageData === 'object' && imageData.srcUrl) {
                setImgSrc(imageData.srcUrl);
            }
        }, 10);
    }, [props.previewScale, imageIndex, props.visualisationComponentKey, props.selectedFeatureNode, props.activeNode, customisationVars, imageData, imageData.srcUrl]);

    const overridePosScale = getCustomisationValue(customisationVars, 'customImageOverlay.imageFiles.customImageFile.overridePosAndSize', imageIndex, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? false;
    const scaleVal = overridePosScale ? getCustomisationValue(customisationVars, 'customImageOverlay.imageFiles.customImageFile.scale', imageIndex, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? 100 : getCustomisationValue(customisationVars, 'customImageOverlay.imageSettings.sizeAndPosition.scale', 0, props.visualisationComponentKey ?? null, props.selectedFeatureNode) ?? 100;

    const actualScale = ((scaleVal ?? 100) / 100) * props.previewScale;
    useEffect(() => {
        if (naturalWidth) {
            const scaledWidth = naturalWidth * actualScale;
            setImgWidth(scaledWidth + 'px');
            setTimeout(() => {
                setImgVisible(true);
                props.forceUpdateComponent();
            }, 50);
        }
    }, [actualScale, naturalWidth]);

    // calculate the width of the image based on the actual scale and the original image width
    const handleImageLoad = (e) => {
        const originalWidth = e.target.naturalWidth;
        setNaturalWidth(originalWidth);
    }

    return (
        <>
            {imgSrc &&
                <img style={{width: imgWidth, opacity: imgVisible ? 1 : 0}} src={imgSrc} alt="Overlay" onLoad={handleImageLoad} />
            }
            {imgSrc === null &&
                <div style={{width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'transparent'}}>
                    {/* <span style={{color: '#fff'}}>No Image</span> */}
                </div>
            }
        </>
    );
}

export default ImageOverlayScaledImage;
